import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing } from '../styles/theme';

const styles = StyleSheet.create({
  container: {
    marginVertical: spacing.md,
  },
  headerRow: {
    flexDirection: 'row',
    backgroundColor: colors.primary,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
  },
  headerCell: {
    ...typography.tableHeader,
  },
  row: {
    flexDirection: 'row',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.border.light,
    borderBottomStyle: 'solid',
  },
  rowAlt: {
    backgroundColor: colors.background.table,
  },
  cell: {
    ...typography.tableCell,
  },
  cellRight: {
    textAlign: 'right',
  },
  // Compact variant
  headerRowCompact: {
    paddingVertical: 4,
    paddingHorizontal: spacing.sm,
  },
  rowCompact: {
    paddingVertical: 4,
    paddingHorizontal: spacing.sm,
  },
  cellCompact: {
    fontSize: 9,
  },
});

const DataTable = ({
  columns,
  data,
  variant = 'default',
  showHeader = true,
  maxRows,
  style,
}) => {
  const isCompact = variant === 'compact';
  const displayData = maxRows ? data.slice(0, maxRows) : data;

  return (
    <View style={[styles.container, style]}>
      {showHeader && (
        <View
          style={[styles.headerRow, isCompact && styles.headerRowCompact]}
        >
          {columns.map((col, idx) => (
            <Text
              key={idx}
              style={[
                styles.headerCell,
                isCompact && styles.cellCompact,
                { width: col.width || 'auto', flex: col.flex || 0 },
                col.align === 'right' && styles.cellRight,
              ]}
            >
              {col.header}
            </Text>
          ))}
        </View>
      )}

      {displayData.map((row, rowIdx) => (
        <View
          key={rowIdx}
          style={[
            styles.row,
            isCompact && styles.rowCompact,
            rowIdx % 2 === 1 && styles.rowAlt,
          ]}
        >
          {columns.map((col, colIdx) => (
            <Text
              key={colIdx}
              style={[
                styles.cell,
                isCompact && styles.cellCompact,
                { width: col.width || 'auto', flex: col.flex || 0 },
                col.align === 'right' && styles.cellRight,
              ]}
            >
              {col.render ? col.render(row) : row[col.key]}
            </Text>
          ))}
        </View>
      ))}

      {maxRows && data.length > maxRows && (
        <Text
          style={{
            ...typography.caption,
            marginTop: spacing.sm,
            fontStyle: 'italic',
          }}
        >
          Mostrando {maxRows} de {data.length} registros
        </Text>
      )}
    </View>
  );
};

export default DataTable;
